import React from "react";
import ReactDom from "react-dom";
import * as utils from "./utils";

export default class ContentCanvas extends React.Component {

    constructor(props) {
        super(props);

        this.state = { url: props.url };
        this.onContentLoad = this.onContentLoad.bind(this);
        this.setFrameRef = React.createRef();
    }

    onContentLoad(e) {
        let title = this.setFrameRef.current.contentDocument.title;

        if (utils.isNullOrWhitespace(title))
            this.props.onNext();
    }

    render() {
        const { url } = this.state;

        return (
            <div className="content-canvas">
                <iframe src={url} onLoad={this.onContentLoad} ref={this.setFrameRef} />
            </div>
        );
    }

}